$( document ).ready(function() {

  var pack = /pack/gi;
  var bar = /bar/gi;
  var bars = /bars/gi;
  
  $('.Flavor_Pack_Count label').contents().each(function() {
    if (this.nodeType === 3 && this.nodeValue.match(pack)) {
      this.nodeValue = this.nodeValue.replace(pack, '');
    }
  });

  $('.Flavor_Pack_Count label').contents().each(function() {
    if (this.nodeType === 3 && this.nodeValue.match(bars)) {
      this.nodeValue = this.nodeValue.replace(bars, '');
    }
  });  
  
  $('.Flavor_Pack_Count label').contents().each(function() {
    if (this.nodeType === 3 && this.nodeValue.match(bar)) {
      this.nodeValue = this.nodeValue.replace(bar, '');
    }
  });


  $('.spr-starrating.spr-summary-starrating').contents().filter(function() {
    return this.nodeType == 3
  }).each(function(){
    this.textContent = this.textContent.replace('(','');
  });
  
  $('.spr-starrating.spr-summary-starrating').contents().filter(function() {
    return this.nodeType == 3
  }).each(function(){
    this.textContent = this.textContent.replace(')','Reviews');
  });

  $('#recommended .flavor-title').matchHeight({ byRow: true });
  
});

$(window).resize(function() {
  $('#recommended .flavor-title').matchHeight({ byRow: true });
});

/*
var myTime = setInterval(function () { myRuntime() }, 9000);
function myRuntime() {
if(document.querySelector('.product__info-container [data-widget-container-wrapper]')){
    console.log('init');
  let html = `<legend class="form__label purchase_options_custom">Purchase Options</legend>`;
  if(document.querySelector('[data-price-mutation-watcher]') && document.querySelector('.purchase_options_custom')==null){
    document.querySelector('[data-price-mutation-watcher]').insertAdjacentHTML('afterend', html);
    clearInterval(myTime);
  }
  if(document.querySelector('.Fresh_Price')==null && document.querySelector('.purchase_options_custom')==null){
    document.querySelector('.Buy_Buttons').insertAdjacentHTML('beforebegin', html);
    clearInterval(myTime);
  }
    document.querySelector('.Fresh_Price').classList.add('hidden');
  }else{
  
  if(document.querySelector('.Fresh_Price .price-item.price-item--regular')){
    let oneTimePriceClone = document.querySelector('.Fresh_Price .price-item.price-item--regular').innerText;
    let oneTimeHtml = `<div class="rc_widget__option__selector custom-onetime-purchase">
                      <label class="rc-radio__label rc_widget__option__label">
                          <span class="rc-option__text" data-label-text-onetime="">One-time purchase</span>
                          <span class="rc-option__price rc_widget__price rc_widget__price--onetime" aria-label="original price">${oneTimePriceClone}</span>
                      </label>
                      </div>`;
    if(document.querySelector('.custom-onetime-purchase')==null){
      document.querySelector('.Fresh_Price').insertAdjacentHTML("afterend", oneTimeHtml);
      document.querySelector('.Fresh_Price').classList.add('hidden');
      clearInterval(myTime);
    }      
  }

  }
};
*/
// setTimeout(function(){
//   if(document.querySelector('.product__info-container #product-form-installment [data-widget-container-wrapper]')){
//     console.log('init');
//   let html = `<legend class="form__label purchase_options_custom">Purchase Options</legend>`;
//   if(document.querySelector('[data-price-mutation-watcher]')){
//     document.querySelector('[data-price-mutation-watcher]').insertAdjacentHTML('afterend', html);
//   }
//     document.querySelector('.Fresh_Price').classList.add('hidden');
//   }else{
//     let oneTimePriceClone = document.querySelector('.Fresh_Price .price-item.price-item--regular').innerText;
//     let oneTimeHtml = `<div class="rc_widget__option__selector custom-onetime-purchase">
//                       <label class="rc-radio__label rc_widget__option__label">
//                           <span class="rc-option__text" data-label-text-onetime="">One-time purchase</span>
//                           <span class="rc-option__price rc_widget__price rc_widget__price--onetime" aria-label="original price">${oneTimePriceClone}</span>
//                       </label>
//                       </div>`;
//     document.querySelector('.Fresh_Price').insertAdjacentHTML("afterend", oneTimeHtml);
//     document.querySelector('.Fresh_Price').classList.add('hidden');
    
//   }
  
//   // if(document.querySelector('.size-selector-wrapper.selector-wrapper.Show_Mobile.Purchase_Options [data-widget-container-wrapper]') == null){
//   //   document.querySelector('.product__info-wrapper .Purchase_Options').remove(); 
//   // }
// },9000)


// pdp subscription changes starts here
/*
let interval = null

let domWorks = () => {
     let d = document.querySelector('.product .rc-container-wrapper')
     if(d) {
       $('.Fresh_Price').addClass('hide-desktop-mobile')
       //$('<div class=purchase-option-text>Purchase Options</div>').insertAfter($( ".product-form__input" ));
       clearInterval(interval)
     }
}
interval = setInterval(domWorks, 100)
*/
// pdp subscription changes ends here

customElements.define('blog-article-list',class blogArticleList extends HTMLElement{
  constructor(){
    super();
    this.querySelectorAll('.js-link-btn').forEach(element => this.btnClickEvent(element))
    this.querySelectorAll('.js--pagination__item').forEach(element => this.btnClickEvent(element))
  }
  btnClickEvent(element){
    let _this = this;
    element.addEventListener('click',function (e) {
      e.preventDefault();
      let scrollSection = false;
      if(this.classList.contains('js--pagination__item') || this.href.includes('/tagged/')) scrollSection = true;
      _this.applyAjax(this.href,scrollSection);
    })
  }
   applyAjax(url,scrollSection = false){
     window.scrollTo({
       top: (scrollSection == true) ? (this.offsetTop - document.querySelector("#shopify-section-header").offsetHeight) : 0,
       behavior:'smooth'
     });
    this.updateUrl(url);
    fetch(url)
    .then(responce => {
      return responce.text();
    })
    .then(data => {
      let newHtml = document.createElement('div');
      newHtml.innerHTML = data;
      document.querySelector('#MainContent').replaceWith(newHtml.querySelector('#MainContent'));
      
    });
  }
  updateUrl(newUrl){
    window.history.pushState(null, null, newUrl);
  }
});
window.addEventListener('popstate', (event) => {
  window.scrollTo({
     top: 0,
     behavior:'smooth'
   });
  fetch(document.location)
  .then(responce => {
    return responce.text();
  })
  .then(data => {
    let newHtml = document.createElement('div');
    newHtml.innerHTML = data;
    document.querySelector('#MainContent').replaceWith(newHtml.querySelector('#MainContent'));
  });
});

customElements.define('slick-slider',class slickSlider extends HTMLElement{
  constructor(){
    super();
    let sliderElement = this.querySelector('.js-initilize-slider');
    if(sliderElement){
      let sliderObjects = JSON.parse(sliderElement.dataset.slickObject);
      $(sliderElement).slick(sliderObjects);
    }
  }
});

$('.logo__list--wrapper').slick({
  infinite: true,
  slidesToShow: 7,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4500,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2,
      }
    }
  ]
});


$(".scroll-locator").click(function() {
    $('html, body').animate({
        scrollTop: $(".store-locator").offset().top - 150
    }, 500);
});